export default {
    url: 'calculators/solarpanels',
    include: ['us', 'za', 'ca', 'uk', 'au'],
};
